<template>
  <div v-loading.fullscreen.lock="fullscreenLoading" class="OnlineInvoicing">
    <div class="flex" style="width: 100%; justify-content: flex-start">
      <div style="flex: 8; width: 100%">
        <!-- 基本信息 -->
        <div class="flex">
          <div class="bg" style="">
            <p>基本信息</p>
            <span @click="According(1)">
              <img v-if="show.basic == true" :src="img.url" alt="" />
              <img v-else :src="img.url1" alt="" />
            </span>
          </div>
          <div style="padding-bottom: 0.8rem" class="box" v-if="show.basic">
            <ul>
              <!-- 交货尺寸 -->
              <li>
                <myTitle
                  class="myTitle"
                  :msg="'交货尺寸'"
                  :explain="explain[1]"
                />
                <div>
                  <el-input
                    size="mini"
                    @blur="BoardSize"
                    @change="DeliveryChange"
                    type="digit"
                    v-model="orderFrom.det_BoardSize_W"
                    placeholder="板子长度"
                  ></el-input>
                  <i>x</i>
                  <el-input
                    v-model="orderFrom.det_BoardSiez_H"
                    @blur="BoardSize"
                    @change="DeliveryChange"
                    type="digit"
                    size="mini"
                    placeholder="板子宽度"
                  ></el-input>
                  <i style="font-size: 1.5rem; margin-top: 10px">cm</i>
                </div>
              </li>
              <!-- 拼板层数 -->
              <li>
                <myTitle
                  class="myTitle"
                  :explain="explain[0]"
                  :msg="'板子层数'"
                />
                <radio-btn
                  @defaulchange="LayerChange"
                  :default="orderFrom.Det_Layer"
                  :list="layerList"
                />
              </li>
              <!-- 交货数量 -->
              <li>
                <myTitle
                  :explain="explain[2]"
                  :msg="'交货数量'"
                  class="myTitle"
                />

                <div>
                  <span>
                    <el-input
                      @input="CanceDialog"
                      @change="DeliveryChange"
                      v-model="orderFrom.det_Num"
                      placeholder="板材数量"
                    >
                    </el-input>
                  </span>
                </div>
              </li>
              <!-- 拼板方式 -->
              <li>
                <myTitle
                  class="myTitle"
                  :explain="explain[0]"
                  :msg="'拼板方式'"
                />
                <radio-btn
                  @defaulchange="puzzlechange"
                  :default="offerFrom.PuzzleMode"
                  :list="puzzleList"
                />
              </li>
              <!-- 工艺边宽度 -->
              <li
                class="flex"
                style="justify-content: space-between"
                v-if="offerFrom.PuzzleMode == 2"
              >
                <myTitle class="myTitle" :msg="'工艺边宽度'" />
                <span style="flex: 1">
                  <el-input
                    v-model="offerFrom.Process_W"
                    size="mini"
                    placeholder="≥3"
                  />cm
                  <span style="font-size: 0.4rem; color: red"
                    >注:云上初阳自由拼版常规在长边添加两条工艺边.“0cm”表示不加工艺边</span
                  >
                </span>
              </li>
              <!-- 拼版的间距 -->
              <li
                class="flex"
                style="justify-content: space-between"
                v-if="offerFrom.PuzzleMode == 2"
              >
                <myTitle class="myTitle" :msg="'拼版的间距'" />
                <span style="flex: 1">
                  <el-input
                    v-model="offerFrom.Process_H"
                    size="mini"
                    placeholder="≥1.6"
                  />cm
                  <span style="font-size: 0.4rem; color: red"
                    >注:中信华自由拼版会根据单板外形结构考虑节省板材及最佳方式进行拼版.
                    “0cm”表示拼版不留边距</span
                  >
                </span>
              </li>

              <li
                v-if="offerFrom.PuzzleMode == 3"
                class="flex"
                style="justify-content: space-between"
              >
                <myTitle class="myTitle" :msg="'拼板方式'"></myTitle>
                <span style="flex: 1">
                  <el-input
                    @input="Process"
                    v-model="offerFrom.Process_W"
                    size="mini"
                    placeholder="板材数"
                  ></el-input>
                  <i>x</i>
                  <el-input
                    @input="Process"
                    v-model="offerFrom.Process_H"
                    size="mini"
                    placeholder="拼版数"
                  ></el-input>
                </span>
              </li>
              <!-- set数量 -->
              <li>
                <myTitle
                  :explain="explain[2]"
                  :msg="'set数量'"
                  class="myTitle"
                />
                <div>
                  <span style="font-size: 1.2rem">
                    {{ getSet }}
                  </span>
                </div>
              </li>
              <!-- 拼板款数 -->
              <li>
                <myTitle
                  :explain="explain[20]"
                  :msg="'拼板款数'"
                  class="myTitle"
                />
                <div>
                  <span>
                    <el-input
                      @blur="PuzzleChanges"
                      v-model="orderFrom.det_Pmodels"
                      placeholder="板材款数"
                    >
                    </el-input>
                  </span>
                </div>
              </li>
              <!-- 板材类型 -->
              <li>
                <myTitle
                  class="myTitle"
                  :explain="explain[5]"
                  :msg="'板材类型'"
                />
                <radio-btn
                  @defaulchange="plankChange"
                  :default="orderFrom.Det_BoardType"
                  :list="plankList"
                />
              </li>

              <!-- 供应商 -->
              <li>
                <myTitle
                  class="myTitle"
                  :msg="'板材供应商'"
                  :explain="explain[21]"
                />
                <radio-btn
                  @defaulchange="supplierChange"
                  :default="orderFrom.Det_BoardSupplier"
                  :list="supplierList"
                />
              </li>
              <!-- 板材具体型号 -->
              <li
                v-if="
                  orderFrom.specificModels != '' &&
                  orderFrom.Det_BoardType == '高频板'
                "
              >
                <myTitle class="myTitle" :msg="'板材具体型号'" />
                <radio-btn
                  @defaulchange="specificistChanges"
                  :default="orderFrom.specificModels"
                  :list="specificistList"
                />
              </li>
              <!-- 成品板厚 -->
              <li>
                <myTitle
                  :explain="explain[4]"
                  :msg="thicknessBoard"
                  class="myTitle"
                />

                <radio-btn
                  @defaulchange="thicknessChange"
                  :default="orderFrom.Det_BoardThickness"
                  :list="thicknessList"
                />
              </li>

              <!-- 成品铜厚 -->
              <li>
                <myTitle
                  :explain="explain[6]"
                  :msg="CopperFoil"
                  class="myTitle"
                />
                <radio-btn
                  @defaulchange="copperThickChange"
                  :default="orderFrom.Det_Copper_out"
                  :list="copperThickList"
                />
              </li>
              <!-- 内层铜厚 -->
              <li v-if="orderFrom.Det_Layer >= 4">
                <myTitle
                  :explain="explain[6]"
                  :msg="InCopperFoil"
                  class="myTitle"
                />
                <radio-btn
                  @defaulchange="theCopperThickChange"
                  :default="orderFrom.Det_Copper_in"
                  :list="theCopperThickList"
                />
              </li>
              <!-- 阻焊颜色 -->
              <li>
                <myTitle
                  :explain="explain[8]"
                  :msg="'阻焊颜色'"
                  class="myTitle"
                />

                <radio-btn
                  @defaulchange="ResistanceChange"
                  :default="orderFrom.Det_ZHcolor"
                  :list="ResistanceList"
                />
              </li>
              <!-- 字符颜色 -->
              <li>
                <myTitle
                  :explain="explain[9]"
                  :msg="'字符颜色'"
                  class="myTitle"
                />
                <radio-btn
                  @defaulchange="characterChange"
                  :default="offerFrom.ZFcolor"
                  :list="characterList"
                />
              </li>
              <!-- 过孔方式 -->
              <li>
                <myTitle
                  :explain="explain[10]"
                  :msg="'过孔方式'"
                  class="myTitle"
                />
                <radio-btn
                  :default="offerFrom.ViaWay"
                  @defaulchange="holeChange"
                  :list="holeList"
                />
              </li>
              <!-- 表面处理 -->
              <li>
                <myTitle
                  :explain="explain[11]"
                  :msg="'表面处理'"
                  class="myTitle"
                />
                <radio-btn
                  @defaulchange="surfaceChange"
                  :default="orderFrom.Det_Surface"
                  :list="surfaceList"
                />
                <!-- <span style="color: #f00; font-size: 10px">注:如是Gerber资料过孔处理一律按文件加工,此选项无效!</span> -->
              </li>
              <!-- 测试 -->
              <li>
                <myTitle
                  :explain="explain[12]"
                  :msg="'测试方式'"
                  class="myTitle"
                />
                <radio-btn
                  @defaulchange="testChange"
                  :list="testList"
                  :default="orderFrom.Det_TestMethod"
                />
              </li>
              <!-- 测试架 -->
              <li
                v-if="
                  orderFrom.Det_TestMethod == '电测' &&
                  orderFrom.Det_BoardType != '高频板'
                "
              >
                <myTitle :msg="'测试架'" class="myTitle" />
                <radio-btn
                  @defaulchange="TestTheChange"
                  :list="TestTheList"
                  :default="orderFrom.Det_Testingjig"
                />
              </li>
              <!-- 测试费 -->
              <li
                v-if="
                  orderFrom.Det_Testingjig == '新开测试架' &&
                  orderFrom.Det_BoardType != '高频板'
                "
              >
                <myTitle
                  :explain="explain[22]"
                  :msg="'测试费'"
                  class="myTitle"
                />
                <radio-btn
                  @defaulchange="pleaseChange"
                  :default="orderFrom.Det_TestPrice"
                  :list="pleaseList"
                />
              </li>
              <!-- 公用测试架 -->
              <li
                v-if="
                  orderFrom.Det_Testingjig == '公用测试架' &&
                  orderFrom.Det_BoardType != '高频板'
                "
              >
                <myTitle :explain="explain[22]" :msg="'型号'" class="myTitle" />
                <drop-down @dropChange="dropChang" :list="pleList" />
              </li>
              <!-- 最小孔径 -->
              <li>
                <myTitle
                  :explain="explain[21]"
                  :msg="'最小孔径'"
                  class="myTitle"
                />
                <radio-btn
                  @defaulchange="apertureChange"
                  :default="offerFrom.aperture"
                  :list="apertureList"
                />
              </li>
              <!-- 生产稿 -->
              <li>
                <myTitle
                  :explain="explain[13]"
                  :msg="'确认生产稿'"
                  class="myTitle"
                />
                <radio-btn
                  @defaulchange="draftChange"
                  :list="draftList"
                  :default="offerFrom.draft"
                />
              </li>
              <!-- 最小线宽 -->
              <li>
                <myTitle
                  :explain="explain[7]"
                  :msg="'最小线宽线距'"
                  class="myTitle"
                />
                <radio-btn
                  @defaulchange="spacingChange"
                  :list="spacingList"
                  :default="orderFrom.Det_LineSpacing"
                />
              </li>

              <!-- 成型方式 -->
              <li>
                <myTitle
                  :explain="explain[14]"
                  :msg="'成型方式'"
                  class="myTitle"
                />
                <radio-btn
                  @defaulchange="moldingChange"
                  :default="orderFrom.Det_MouldManner"
                  :list="moldingList"
                />
              </li>

              <!-- 模具 -->
              <li
                v-if="
                  orderFrom.Det_MouldManner == '模冲' &&
                  orderFrom.Det_BoardType != '高频板'
                "
              >
                <myTitle :msg="'模具'" class="myTitle" />
                <radio-btn
                  @defaulchange="abrasiveChange"
                  :list="abrasiveList"
                  :default="orderFrom.Det_mould"
                />
              </li>
              <li v-if="orderFrom.Det_mould == '公用模具'">
                <myTitle :msg="'型号'" class="myTitle" />
                <drop-down @dropChange="dropChan" :list="abrasiveList" />
              </li>
              <!-- 订单号/物料编号 -->
              <li>
                <myTitle
                  :explain="explain[14]"
                  :msg="'订单/物料 号'"
                  class="myTitle"
                />
                <div>
                  <el-input
                    size="mini"
                    type="digit"
                    v-model="orderFrom.TorderNo"
                    placeholder="订单/物料 号"
                  />
                </div>
              </li>
            </ul>
          </div>
        </div>
        <!-- 特殊工艺 -->
        <div class="flex">
          <div class="bg">
            <p>特殊选项</p>
            <span @click="According(4)">
              <img v-if="show.special == true" :src="img.url" alt="" />
              <img v-else :src="img.url1" alt="" />
            </span>
          </div>
          <div
            style="padding-bottom: 0.8rem"
            class="box flex"
            v-if="show.special"
          >
            <ul>
              <!-- 加厂编 -->
              <li>
                <myTitle
                  :explain="explain[15]"
                  :msg="'加厂编'"
                  class="myTitle1"
                />
                <checkbox-btn
                  :default="offerFrom.CharacterTagsArray"
                  @defaulchanges="characterTagChange"
                  :list="characterTagList"
                />
              </li>
              <!--丝印周期 -->
              <li v-if="isBJ">
                <myTitle
                  :explain="explain[16]"
                  :msg="'添加标记'"
                  class="myTitle1"
                />
                <radio-btn
                  @defaulchange="ScreenChange"
                  :default="offerFrom.Screen"
                  :list="ScreenList"
                />
              </li>
              <!-- 特殊工艺 -->
              <li>
                <myTitle
                  :explain="explain[17]"
                  :msg="'特殊工艺'"
                  class="myTitle1"
                />
                <div style="display: flex">
                  <checkbox-btn
                    @defaulchanges="specialChange"
                    :default="specialArray"
                    :list="specialList"
                  />
                  <i style="color: #f00; font-size: 0.8rem"
                    >注:此栏工艺为可选项,没有可不选</i
                  >
                </div>
              </li>
            </ul>
          </div>
        </div>
        <!-- 其他信息 -->
        <div class="flex" style="margin-bottom: 1rem">
          <div class="bg">
            <p>其他信息</p>
            <span @click="According(5)">
              <img v-if="show.other == true" :src="img.url" alt="" />
              <img v-else :src="img.url1" />
            </span>
          </div>
          <div class="box" v-if="show.other">
            <ul>
              <!-- 数据收货单 -->
              <li>
                <myTitle
                  class="myTitle"
                  :explain="explain[21]"
                  :msg="'收据/送货单'"
                />
                <radio-btn
                  @defaulchange="receiptChange"
                  :default="orderFrom.Det_Receipt"
                  :list="receiptList"
                />
              </li>
              <!-- 打叉板 -->
              <li>
                <myTitle
                  class="myTitle"
                  :explain="explain[21]"
                  :msg="'接受打叉板'"
                />
                <radio-btn
                  :list="standardList"
                  @defaulchange="standardChange"
                  :default="offerFrom.standard"
                />
              </li>
              <!-- 接受标准 -->
              <li>
                <myTitle
                  class="myTitle"
                  :explain="explain[21]"
                  :msg="'接收标准'"
                />
                <radio-btn
                  :list="AcceptanceList"
                  :default="offerFrom.Acceptance"
                  @defaulchange="AcceptanceChange"
                />
              </li>

              <li style="margin-bottom: 1rem">
                <myTitle
                  :msg="'发票信息'"
                  :explain="explain[21]"
                  class="myTitle"
                />
                <radio-btn
                  @defaulchange="invoiceChange"
                  :list="invoiceList"
                  :default="orderFrom.Det_Isinvoice"
                />
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div>
        <is-show :content="content" :ishow="isShow" />
      </div>
      <!-- 计价详情栏 -->
      <div v-cloak class="table" style="flex: 3">
        <div class="headr">
          <hr />
          <i>PCB报价和交期</i>
          <hr />
        </div>
        <div>
          <div class="price" style="margin-left: 1rem">
            PCB价格: <i style="color: #f00">￥{{ Denominated.Ord_Price }}</i
            ><i
              @click="show3 = !show3"
              style="
                float: right;
                font-size: 1rem;
                margin-right: 3rem;
                color: #000;
              "
              >明细</i
            >
          </div>

          <el-collapse-transition>
            <div class="detail" v-show="show3">
              <div>
                <div>
                  <span>工程费:</span
                  ><i>￥{{ Denominated.Ordp_Engineering }}</i>
                </div>
                <div>
                  <span>板费:</span> <i>￥{{ Denominated.Ordp_MakeBoard }}</i>
                </div>
                <div>
                  <span>菲林费:</span> <i>￥{{ Denominated.Ordp_FilmCount }}</i>
                </div>
                <div>
                  <span>其他费:</span> <i>￥{{ Denominated.Ordp_Other }}</i>
                </div>
                <div>
                  <span>税费:</span> <i>￥{{ Denominated.Ordp_Invoice }}</i>
                </div>
              </div>
            </div>
          </el-collapse-transition>
        </div>

        <div>
          <div style="padding-top: 0.7rem">
            <hr />
            <i>商品价格</i>
            <hr />
          </div>
          <div class="box">
            <div>
              <div>数量</div>
              <div>面积</div>
              <div>平米价</div>
            </div>
            <div>
              <div style="color: #f00">{{ getnumberOf }}</div>
              <div style="color: #f00">{{ getArea }}m²</div>
              <div style="color: #f00">￥{{ areaPrice }}</div>
            </div>
          </div>
        </div>
        <div>
          <div style="padding-top: 1rem">
            <hr />
            <i>订单交期</i>
            <hr />
          </div>
          <div class="delivery">
            <el-radio
              style="color: #000"
              v-model="radio2"
              label="1"
              border
              size="medium"
              >正常交期:{{ DeliveryDate }}</el-radio
            >
            <!-- <el-radio
              style="color: #000"
              v-model="radio2"
              label="2"
              border
              size="medium"
              >加急交期:2021-02-03
              <img
                style="width: 1rem"
                src="../../assets/imges/10101.png"
                alt=""
              />
              <i style="color: #f00">3天加急</i>
            </el-radio> -->
            <!-- <el-radio
              style="color: #000"
              v-model="radio2"
              label="3"
              border
              size="medium"
              >加急交期:2021-02-03
              <img
                style="width: 1rem"
                src="../../assets/imges/10101.png"
                alt=""
              />
              <i style="color: #f00">4天加急</i>
            </el-radio> -->
          </div>
          <div
            style="
              color: #f00;
              font-size: 0.8rem;
              padding-top: 1rem;
              width: 80%;
              margin: auto;
            "
          >
            注:订单确认付款时间超过17:00,交货日期从第二天开始计算
          </div>
          <div class="cost">
            <div>
              订单费用: <i style="color: #f00">￥{{ Denominated.Ord_Price }}</i>
            </div>
            <div>
              费用总计: <i style="color: #f00">￥{{ Denominated.Ord_Price }}</i>
            </div>
          </div>
          <div style="display: flex">
            <el-button
              style="background-color: #83cbac; color: #fff"
              @click="order"
              >立即计价</el-button
            >
            <el-button
              style="background-color: #dbaf18; color: #fff"
              @click="AddShopping"
              >加入购物车</el-button
            >
            <el-button
              @click="orderImmediately"
              style="background-color: #6fbf64; color: #fff"
              >立即下单</el-button
            >
          </div>
        </div>
      </div>
      <!-- 查看计价 -->
      <!-- <div class="table" style="flex: 3">
        <el-button @click="order" type="primary">计价</el-button>

        <div>
          <div>制版费:{{ Denominated.Ordp_MakeBoard }}</div>
          <div>
            平米单价:{{
              Denominated.Ordp_MakeBoard /
              ((orderFrom.det_BoardSize_W *
                orderFrom.det_BoardSiez_H *
                orderFrom.det_Num) /
                10000)
            }}
          </div>
          <div>
            单片:{{
              (
                Denominated.Ordp_MakeBoard /
                ((orderFrom.det_BoardSize_W *
                  orderFrom.det_BoardSiez_H *
                  orderFrom.det_Num) /
                  10000 /
                  offerFrom.PuzzleMode !=
                "3"
                  ? "1"
                  : offerFrom.Process_W * offerFrom.Process_H) /
                orderFrom.det_Num
              ).toFixed(2)
            }}
          </div>
          <div>工程费:{{ Denominated.Ordp_Engineering }}</div>
          <div>铜厚费:{{ Denominated.Ordp_Copper }}</div>
          <div>表面处理费:{{ Denominated.Ordp_Surface }}</div>
          <div>锣程费:{{ Denominated.Ordp_LUO }}</div>
          <div>杂油费:{{ Denominated.Ordp_SMType }}</div>
          <div>菲林费:{{ Denominated.Ordp_FilmCount }}</div>
          <div>测试费:{{ Denominated.Ordp_TestMethod }}</div>
          <div>模具费:{{ Denominated.Ordp_Mould }}</div>
          <div>其他费用:{{ Denominated.Ordp_Other }}</div>
          <div>税费:{{ Denominated.Ordp_Invoice }}</div>
          <div>总费用:{{ Denominated.Ord_Price }}</div>
          <div>数量:{{ orderFrom.det_Num }}</div>
          <div>
            总费用/数量:{{
              (Denominated.Ord_Price / orderFrom.det_Num).toFixed(2)
            }}
          </div>
          <div>
            面积:{{
              (orderFrom.det_BoardSize_W *
                orderFrom.det_BoardSiez_H *
                orderFrom.det_Num) /
              10000 /
              (offerFrom.PuzzleMode == "3"
                ? offerFrom.Process_W * offerFrom.Process_H
                : 1)
            }}m²
          </div>
          <h5>其他费用明细</h5>
          <hr />
          <div>PP费:{{ Denominated.Ordp_PP }}</div>
          <div>孔数费:{{ Denominated.Ordp_Hole }}</div>
          <div>特殊工艺费:{{ Denominated.Ordp_technique }}</div>
          <div>款数费:{{ Denominated.Ordp_Pmodels }}</div>
          <div>线宽线距费:{{ Denominated.Ordp_LineSpacing }}</div>
          <div>送货单费用:{{ Denominated.Ordp_Receipt }}</div>
        </div>
      </div> -->
    </div>
  </div>
</template>
<script>
import title from "../../components/PrivateComponent/title";
import { getOrderApi } from "../../api/http/order";
import radioBtn from "../../components/Denominated/radioBtn.vue";
import checkboxBtn from "../../components/Denominated/checkboxBtn.vue";
import isShow from "../../components/isPrompt/index.vue";
import dropDown from "../../components/Denominated/dropDown.vue";
export default {
  data() {
    return {
      InCopperFoil: "内层铜厚",
      thicknessBoard: "成品板厚", //板材厚度名称
      CopperFoil: "成品外层铜厚", //
      orderFrom: {
        specificModels: "", //板材具体
        mould1Xh: "", //模具型号
        textModel: "", //型号
        TorderNo: "", //订单号
        det_BoardSize_W: "", //板子长
        det_BoardSiez_H: "", //板子高
        det_Num: "", //板子数量
        Det_Layer: "2", //板子层数
        Det_BoardType: "FR-4", //板子类型
        Det_BoardThickness: "0.8", //板子厚度
        Det_BoardSupplier: "国纪", //板材供应商
        Det_Copper_out: "1", //外成铜厚
        Det_Copper_in: "1", //内层铜厚
        Det_ZHcolor: "绿色", //阻焊颜色
        Det_Surface: "有铅喷锡", //表面处理
        Det_TestPrice: 0, //测试费
        Det_Testingjig: "", //测试架
        Det_MouldManner: "铣边", //成型方式
        Det_mould: "", //模具
        Det_Isinvoice: "0", //发票信息
        det_Pmodels: "1", //板材款数
        Det_TestMethod: "目测", //测试
        Det_Receipt: "1", //收据送货单
        Det_LineSpacing: "10/10", //最小线宽线距
        det_IsHalfHole: 0, //半孔
        det_IsImp: 0, //阻抗
        det_IsBGA: 0, //BGA
        area: "", //面积
      }, //计价表

      pleList: [],
      offerFrom: {
        PuzzleMode: 1, //拼版方式
        set: 0, //set数
        ZFcolor: "黑色", //字符颜色
        ViaWay: "按Gerber文件", //过孔方式
        aperture: "0.8", //最小孔径
        draft: "不需要", //确认生产稿
        Screen: "", //丝印周期
        standard: "1", //打叉板
        Acceptance: "2", //接受标准
        Process_W: "", //工艺边宽度
        Process_H: "", //工艺边间距
        // 厂编数组
        CharacterTagsArray: ["飞天厂编"],
      },
      // 发票信息
      invoiceList: [
        { label: "0", value: "不开发票" },
        { label: "1", value: "增值发票" },
      ],
      // 接受标准
      AcceptanceList: [{ label: "2", value: "IPC-A-600J 2级接受标准" }],
      // 打叉板
      standardList: [{ label: "1", value: "接受打叉板" }],
      // 收据送货单
      receiptList: [
        { label: "2", value: "电子收据/送货单" },
        { label: "1", value: "纸质收据/送货单(样板订单收费0.5/元)" },
      ],
      specialArray: [],
      // 特殊工艺
      specialList: ["半孔", "阻抗", "BGA"],
      // 丝印周期
      ScreenList: [
        { label: "印周年", value: "印周年" },
        { label: "印年周", value: "印年周" },
      ],

      // 字符标记
      characterTagList: [
        "飞天厂编",
        "FTPCB标志",
        "UL标记",
        "RoHS标记",
        "丝印周期",
      ],
      // 模具
      abrasiveList: [
        { label: "新开模具", value: "新开模具" },
        { label: "公用模具", value: "公用模具" },
      ],
      // 成型
      moldingList: [
        { label: "铣边", value: "铣边" },
        { label: "模冲", value: "模冲" },
      ],
      // 测试费
      pleaseList: [
        { label: "500", value: "500" },
        { label: "1000", value: "1000" },
      ],
      // 测试架
      TestTheList: [
        { label: "新开测试架", value: "新开测试架" },
        { label: "公用测试架", value: "公用测试架" },
      ],
      // 最小线宽线距
      spacingList: [
        { label: "4/5", value: "4/5mil" },
        { label: "5/5", value: "5/5mil" },
        { label: "6/6", value: "6/6mil" },
        { label: "7/7", value: "7/7mil" },
        { label: "8/8", value: "8/8mil" },
        { label: "9/9", value: "9/9mil" },
        { label: "10/10", value: "10/10mil" },
      ],
      // 确认生产稿
      draftList: [
        { label: "需要", value: "需要" },
        { label: "不需要", value: "不需要" },
      ],
      // 测试
      testList: [
        { label: "目测", value: "目测" },
        { label: "飞针", value: "飞针" },
        { label: "电测", value: "电测" },
      ],
      // 表面处理
      surfaceList: [
        { label: "有铅喷锡", value: "有铅喷锡" },
        { label: "无铅喷锡", value: "无铅喷锡" },
        { label: "OSP", value: "OSP" },
        { label: "沉金1U", value: "沉金1U" },
        { label: "沉金2U", value: "沉金2U" },
      ],
      // 最小孔径数组
      apertureList: [
        { label: "0.3", value: "0.30mm" },
        { label: "0.35", value: "0.35mm" },
        { label: "0.4", value: "0.40mm" },
        { label: "0.5", value: "0.50mm" },
        { label: "0.6", value: "0.60mm" },
        { label: "0.7", value: "0.70mm" },
        { label: "0.8", value: "0.80mm" },
      ],

      // 过孔方式数组
      holeList: [
        { label: " 过孔盖油", value: "过孔盖油" },
        { label: " 过孔开窗", value: "过孔开窗" },
        { label: "按Gerber文件", value: "按Gerber文件" },
      ],
      characterList: [
        { label: "黑色", value: "黑色" },
        { label: "白色", value: "白色" },
        { label: "无色", value: "无色" },
      ], //字符颜色
      ResistanceList: [
        { label: "绿色", value: "绿色" },
        { label: "蓝色", value: "蓝色" },
        { label: "黄色", value: "黄色" },
        { label: "白色", value: "白色" },
        { label: "黑色", value: "黑色" },
      ], //阻焊颜色
      // 内层铜厚
      theCopperThickList: [
        { label: "1", value: "1oz" },
        { label: "1.5", value: "1.5oz" },
        { label: "2", value: "2oz" },
      ],
      // 外层铜厚
      copperThickList: [
        { label: "1", value: "1oz" },
        { label: "1.5", value: "1.5oz" },
        { label: "2", value: "2oz" },
      ],
      // 板材供应商
      supplierList: [
        { label: "国纪", value: "国纪" },
        { label: "建滔", value: "建滔" },
        { label: "生益", value: "生益" },
        { label: "无要求", value: "无要求" },
      ], //板材供应商数组
      thicknessList: [
        { label: "0.4", value: "0.4" },
        { label: "0.6", value: "0.6" },
        { label: "0.8", value: "0.8" },
        { label: "1", value: "1.0" },
        { label: "1.2", value: "1.2" },
        { label: "1.6", value: "1.6" },
        { label: "2", value: "2.0" },
      ], //板子厚度数组
      MouldHidden: false,
      puzzleList: [
        { label: "1", value: "单拼" },
        { label: "2", value: "云上初阳代拼" },
        { label: "3", value: "客户自拼" },
      ], //拼版方式数组
      layerList: [
        { label: "1", value: "1" },
        { label: "2", value: "2" },
        { label: "4", value: "4" },
      ], //板子层数数组
      plankList: [
        { label: "FR-4", value: "FR-4" },
        { label: "高频板", value: "高频板" },
      ],
      specificistList: [], //板材具体型号
      //  传入解释
      explain: [
        {
          text1: "拼板方式:",
          text2: `
          出货的板子外形尺寸不能小于10*10 (单位:CM),低于此标准,建议拼板出货.如果单板尺寸大于此标准,您也可以选择不拼版.
          拼板出货有两种选择:客户自己拼板,提供拼板图纸;飞天代为拼板.客户自己拼板的,拼板尺寸一定要大于10*10 (单位:CM),
          下单时将拼板图纸一并上传给飞天,飞天按照拼板图纸制作.飞天代为拼板的,审核会根据单板外形结构考虑节省板材及最佳方式进行拼板,
          默认在长边添加两条工艺边,工程制作时默认在工艺边上添加定位孔(2.0mm)和MARK点(1.0mm).如您对拼板有特殊要求下单在备注栏注明清楚即可.
          另:最大拼版尺寸不得超过60*52cm.`,
        }, //平板方式
        {
          text1: "交货尺寸:",
          text2: `板子尺寸是指的是客户投单板子的长和宽,如果是圆形板,长宽尺寸就是圆的直径;如果是外形不规则的电路板,长宽尺寸则按最大的外形范围测量,即为贵司交货的PCB外形尺寸范围(长*宽)单位CM.PCB外形加工生产均是有公差控制,常规锣板外形公差为+/-0.15MM,V-CUT处外形公差为+/-0.3MM.`,
        }, //交货尺寸
        {
          text1: "交货数量:",
          text2:
            "一般按照PCS为单位计算,在线下单板子数量为5的倍数,下单最少5set起订.(未拼板的,按照最少5pcs)",
        }, //交货数量
        {
          text1: "板子层数:",
          text2: `提供的板子层数选择:0为光板(不含铜),1为单面板,2为双面板,4为四层板,6为六层板,层数越大相应费用越高.如果是一面有线路,一面为独立焊盘,此种类型的电路板可做双面,也可做单面,我们根据您的选择加工制作.`,
        }, //板子层数
        {
          text1: "板子厚度",
          text2: `板子厚度指的是PCB成品要达到的厚度,包含铜箔,阻焊油墨,文字油墨和表面处理的厚度.板厚公差:成品板厚＜1.0mm的,公差为±0.1mm；成品板厚≥1.0mm的,公差为成品板厚的10%.`,
        }, //板子厚度
        {
          text1: "板材类型",
          text2: `FR4覆铜板是玻璃纤维环氧树脂覆铜板的简称.目前只做常规TG值板材.`,
        }, //板材类型
        {
          text1: "成品铜厚:",
          text2: `普通板铜箔厚度为1 OZ(35um),工艺需求时可选2OZ(70um)铜箔厚度,在此需注意:2 OZ铜厚的费用肯定要比1 OZ铜厚稍贵.`,
        }, //成品铜厚
        {
          text1: "最小线宽/线距:",
          text2:
            "不同铜厚会对线宽线距有不同要求,完成铜厚1oz,线宽线距最小为6/6mil；完成铜厚1.5oz,线宽线距最小为8/8mil；完成铜厚2oz,线宽线距最小为10/10mil.",
        }, //最小线宽/线距
        {
          text1: "阻焊颜色说明:",
          text2: `部分特殊颜色加收颜色费,如哑光绿、哑光黑以及黄油黑字或绿油黑字等
                阻焊颜色指的是覆盖在电路板表面作为保护层的油墨颜色,考虑生产成本及效率,绿色为常规色,不收取费用.其他颜色是为杂色油墨,加收10元/㎡.
               常规油墨(绿色)阻焊桥:完成铜厚为1oz时,IC间距≥0.23mm做桥,IC间距＜0.23mm开通窗；完成铜厚为2oz时,IC间距≥0.3mm做桥,IC间距＜0.3mm开通窗,其他油墨IC间距数值需加大.绿油、蓝油阻焊桥为0.1mm,其他油墨阻焊桥为0.15mm.`,
        }, //阻焊颜色
        {
          text1: "字符颜色",
          text2: `指的是电路板字符色,单面字符不收取费用,双面字符加收5元/平米(因双面字符生产需2个网版)`,
        }, //字符颜色
        {
          text1: "过孔方式:",
          text2: `如果提供的是gerber文件,一律按文件加工,此选项无效,我们工程会以Gerber文件为准处理资料；若您提供的源文件并且有定义过孔属性,我们工程会按照过孔处理栏选定的处理方式处理资料.
             *过孔盖油检验标准是过孔在锡炉的时候不沾锡.过孔盖油会出现孔口发黄现象,属于工艺正常现象!`,
        }, //过孔方式
        {
          text1: "表面处理",
          text2: `指的是电路板的表面处理,因自然界的铜在空气中倾向于以氧化物形式存在,不太能长期保存为原铜,表面处理其基本目的就是保证良好的可焊性或电性能.表面处理厚度:喷锡≥1um,OSP 0.2-0.5um,沉金≥1u”.`,
        }, //表面处理
        {
          text1: "测试方式",
          text2: `抽测:不收取费用,直通率95%以上,但只是针对比较简单,线宽线距比较大且稀疏、孔也比较大的板子,选择抽测试的订单,将允许存在一定比例的不良品,线路板报废不能使用,我司只赔偿线路板本身价格,其他费用不予赔偿.请慎重选择.
                   目测:不收取费用,因PCB板不同行业,线路难易度不同,目测成品良率达95%左右,如果良率低于95%,线路板报废不能使用,我司只赔偿线路板本身价格,其他费用不予赔偿.
                   电测:开测试架测试,速度快,良率100% 一次性费用,返单资料无更改测试不收费.测试架适用于大批量测试 ,费用与板子层数和测试点数有关.
                  飞针:飞针机器测试,速度慢,良率100% 根据/㎡收费  (不足1㎡按最低计算).
                   说明:板子尺寸≥60CM测试方式不能选择飞针,只能选择目测或者电测,加长板目测,我司不保证良率,所以建议加长板电测.`,
        }, ///测试方式
        {
          text1: "确认生产稿:",
          text2: `生产稿是指我司工程优化后的gerber文件,勾选了需要选项,将对生产文件进行最终确认,订单交期将按确认生产稿时间重新计算.`,
        }, //确认生产稿
        {
          text1: "成型方式:",
          text2: `①锣边成型:板边光滑无披锋,常规公差+/-0.15MM,速度慢,适用样板及中小批量成型铣边外形规则四方四正无内槽的不收费,不规则有内槽的以系统实际收费为准.
           ②模冲成型:板边会有披锋,常规公差+/-0.15MM,速度很快,适用批量成型开模一次性费用,返单资料无更改成型不收费.费用与板子尺寸和外形设计有关,具体以系统报价为准.`,
        }, //成型方式
        {
          text1: "字符标记",
          text2: `如果有工艺边,我司默认在工艺边加上我司厂编.其他标记将根据您的选择添加.如果您有自己的标记需要添加,请提供需添加标记的gerber资料给到我们.`,
        }, //字符标记
        {
          text1: "丝印周期:",
          text2: `年周和周年格式为：8888；我们根据实际情况调整周期。`,
        }, //丝印周期
        {
          text1: "特殊工艺:",
          text2: `半孔完成孔径最小为1mm.如果您有斜边要求,请提供斜边图,需要有斜边角度,深度和角度.`,
        }, //特殊工艺
        {
          text1: "是否阻抗:",
          text2: `如果有阻抗需求,下单时请提供需控制阻抗线路的高亮显示图,参考层和需要控制的阻抗值大小.`,
        }, //是否阻抗
        {
          text1: "BGA",
          text2: `BGA直径最小0.3mm.`,
        }, //BGA
        {
          text1: "拼版款数说明",
          text2: `注:是指文件内不同款的板子个数,包含几个不同的板子时,收取合拼费,如果是同一款板拼版则不收合拼费.拼版划分:电路板中间打邮票孔、开槽、V割、直接铣开都算拼版.`,
        }, //拼版款数说明
        {
          text1: "",
          text2: "",
        }, //测试费
        {
          text1: "测试费",
          text2: `备注：选择新开测试架，出测试费选项：[最低收费]500元（注：收取500元，测试费用凡是在1500点以内全包，超出1500点按实际费用补收，测试架以及费用均不退还）。
                [正常收费]1000元（注：收取1000元，超出1000元按实际费用补收，单款订单金额两年内累计达10万元货款可退还1000元费用或者退还测试架，二选一）。`,
        },
      ],
      content: "", //弹窗内容
      isShow: false, //弹窗显示
      radio2: "1",
      show3: false, //明细影藏
      fullscreenLoading: false, //加载框
      Denominated: {
        Ordp_MakeBoard: 0, //平米单价
        Ordp_Engineering: 0, //工程费
        Ordp_SMType: 0, //杂油费
        Ordp_Surface: 0, //表面工艺费
        Ordp_LUO: 0, //锣程费
        Ordp_FilmCount: 0, //菲林费
        Ordp_Other: 0, //其他费用
        Ordp_Mould: 0, // 模具费
        PlateFee: 0, //板材费
        Ordp_TestMethod: 0, //测试费
        JackFee: 0, //塞孔费
        Ordp_Invoice: 0, //税费
        Ordp_Copper: 0, //铜厚
        Ord_Price: 0, //合计
      }, // 价格

      // 板子类型数
      pcs: "pcs",
      single: false,

      //点选择框显示和隐藏
      Accordin: {
        radio: false,
      },
      // 输入框单选
      radio: [
        { number: 5 },
        { number: 10 },
        { number: 15 },
        { number: 20 },
        { number: 25 },
        { number: 30 },
        { number: 50 },
        { number: 75 },
        { number: 100 },
        { number: 125 },
        { number: 150 },
        { number: 200 },
        { number: 250 },
        { number: 300 },
        { number: 350 },
        { number: 400 },
        { number: 450 },
        { number: 500 },
        { number: 700 },
        { number: 800 },
        { number: 900 },
        { number: 1000 },
        { number: 1500 },
        { number: 2000 },
        { number: 2500 },
        { number: 3500 },
        { number: 4000 },
        { number: 4500 },
        { number: 5000 },
        { number: 5500 },
        { number: 6500 },
        { number: 7000 },
        { number: 7500 },
        { number: 8000 },
        { number: 9000 },
        { number: 10000 },
      ],

      // 页面头上的展开和收起箭头图片
      img: {
        url: require("../../assets/imges/收起.png"),
        url1: require("../../assets/imges/展开.png"),
      },
      //  计价上头部点击切换
      show: {
        basic: true, //基本信息
        PCB: true, //PCB工艺
        personality: true, //个性化选项
        special: true, //特殊工艺
        other: true, //其他
      },
      TestTheHide: false,
      areaPrice: 0, //面积单价
      isBJ: false, //添加字符
      DeliveryDate: "",
    };
  },
  computed: {
    // set数的计算属性方法
    getSet() {
      if (
        this.orderFrom.det_BoardSize_W != "" &&
        this.orderFrom.det_BoardSiez_H != "" &&
        this.orderFrom.det_Num != ""
      ) {
        if (this.offerFrom.PuzzleMode == "3") {
          if (
            this.offerFrom.Process_H != "" &&
            this.offerFrom.Process_W != ""
          ) {
            this.offerFrom.set =
              this.orderFrom.det_Num /
              (this.offerFrom.Process_H * this.offerFrom.Process_W);
            return this.offerFrom.set.toFixed(2);
          } else {
            return (this.offerFrom.set = 0);
          }
        } else {
          return (this.offerFrom.set = this.orderFrom.det_Num);
        }
      } else {
        return (this.offerFrom.set = 0);
      }
    },
    // 数量计算属性
    getnumberOf() {
      let number = 0;
      if (this.orderFrom.det_Num != "") {
        return (number = this.orderFrom.det_Num);
      } else {
        return (number = 0);
      }
    },
    // 面积计算
    getArea() {
      let area = 0;
      if (
        this.orderFrom.det_BoardSiez_H != "" &&
        this.orderFrom.det_BoardSize_W != "" &&
        this.orderFrom.det_Num
      ) {
        if (this.offerFrom.PuzzleMode != "3") {
          area =
            (this.orderFrom.det_BoardSize_W *
              this.orderFrom.det_BoardSiez_H *
              this.orderFrom.det_Num) /
            10000;
          return area.toFixed(2);
        } else {
          area =
            (this.orderFrom.det_BoardSiez_H *
              this.orderFrom.det_BoardSize_W *
              this.orderFrom.det_Num) /
            10000 /
            (this.offerFrom.Process_W * this.offerFrom.Process_H);
          return area.toFixed(2);
        }
      } else {
        return (area = 0);
      }
    },
  },
  created() {
    let data = new Date();
    this.DeliveryDate = this.AddDays(data, 7);
  },
  methods: {
    DeliveryChange() {
      let data = new Date();
       let num=0

      if (
        this.orderFrom.det_BoardSize_W != "" &&
        this.orderFrom.det_BoardSiez_H != "" &&
        this.orderFrom.det_Num
      ) {
        num =
          (this.orderFrom.det_BoardSize_W *
            this.orderFrom.det_BoardSiez_H *
            this.orderFrom.det_Num) /
          10000;
          console.log(num)
        if (num <= 20) {
          this.DeliveryDate = this.AddDays(data, 7);
        } else if (num > 20 && num <= 100) {
          this.DeliveryDate = this.AddDays(data, 9);
        } else if (num > 100) {
          this.DeliveryDate = this.AddDays(data, 10);
        }else{
          return
        }
      }
    },
    AddDays(date, days) {
      undefined;
      var nd = new Date(date);
      nd = nd.valueOf();
      nd = nd + days * 24 * 60 * 60 * 1000;
      nd = new Date(nd);
      var y = nd.getFullYear();
      var m = nd.getMonth() + 1;
      var d = nd.getDate();
      if (m <= 9) m = "0" + m;
      if (d <= 9) d = "0" + d;
      var cdate = y + "-" + m + "-" + d;
      console.log(cdate);
      return cdate;
    },
    specificistChanges(e) {
      this.orderFrom.specificModels = e;
      if (
        (e == "S7439HW" || e == "S7439HW-ANT") &&
        this.orderFrom.Det_Layer == "1"
      ) {
        this.thicknessList = [
          { label: "0.203", value: "0.203" },
          { label: "0.787", value: "0.787" },
        ];
        return (this.orderFrom.Det_BoardThickness = "0.203");
      } else if (e == "SG3300" && this.orderFrom.Det_Layer == "1") {
        this.thicknessList = [{ label: "1.524", value: "1.524" }];
        return (this.orderFrom.Det_BoardThickness = "1.524");
      }
      if (
        (e == "S7439HW" || e == "S7439HW-ANT") &&
        this.orderFrom.Det_Layer == "2"
      ) {
        this.thicknessList = [
          { label: "0.203", value: "0.203" },
          { label: "0.787", value: "0.787" },
        ];
        return (this.orderFrom.Det_BoardThickness = "0.203");
      } else if (e == "SCGA-500GF300" && this.orderFrom.Det_Layer == "2") {
        this.thicknessList = [{ label: "0.762", value: "0.762" }];
        return (this.orderFrom.Det_BoardThickness = "0.762");
      } else if (e == "SG3300" && this.orderFrom.Det_Layer == "2") {
        this.thicknessList = [{ label: "1.524", value: "1.524" }];
        return (this.orderFrom.Det_BoardThickness = "1.524");
      }
    },
    // 模具型号
    dropChan() {
      this.orderFrom.mould1Xh = e;
    },
    // 测试架型号
    dropChang(e) {
      this.orderFrom.textModel = e;
    },
    // 立即下单
    orderImmediately() {
      if (!window.sessionStorage.getItem("token")) {
        return this.$router.push({ path: "/login" });
      }
      let this_ = this;
      this_.content = "";
      this_.isShow = false;
      this.order().then((res) => {
        setTimeout(() => {
          if (this.Denominated.Ord_Price != 0) {
            this_.$router.push({
              path: "/orderImmediately",
              query: {
                id: 2,
                orderFrom: this_.orderFrom,
                offerFrom: this_.offerFrom,
                Denominated: this_.Denominated,
              },
            });
          } else {
            this_.content = "下单失败!!";
            this_.isShow = true;
          }
        }, 500);
      });

      // this.order().then((res) => {

      // });
    },
    // 加入购物车
    AddShopping() {
      let this_ = this;
      this_.content = "";
      this_.isShow = false;
      let obj = {
        Det_BoardSize_W: parseFloat(this.orderFrom.det_BoardSize_W),
        Det_BoardSiez_H: parseFloat(this.orderFrom.det_BoardSiez_H),
        Det_Num: parseFloat(this.orderFrom.det_Num),
        Det_Pmodels: parseFloat(this.orderFrom.det_Pmodels),
        Det_BoardType: this.orderFrom.Det_BoardType,
        Det_BoardSupplier: this.orderFrom.Det_BoardSupplier,
        Det_Layer: parseFloat(this.orderFrom.Det_Layer),
        Det_BoardThickness: this.orderFrom.Det_BoardThickness,
        Det_Copper_out: this.orderFrom.Det_Copper_out,
        Det_Copper_in: this.orderFrom.Det_Copper_in,
        Det_ZHcolor: this.orderFrom.Det_ZHcolor,
        Det_TestMethod: this.orderFrom.Det_TestMethod,
        Det_Testingjig: this.orderFrom.Det_Testingjig,
        Det_Surface: this.orderFrom.Det_Surface,
        Det_TestPrice: parseInt(this.orderFrom.Det_TestPrice),
        Det_Receipt: parseInt(this.orderFrom.Det_Receipt),
        Det_LineSpacing: this.orderFrom.Det_LineSpacing,
        Det_MouldManner: this.orderFrom.Det_MouldManner,
        Det_mould: this.orderFrom.Det_mould,
        Det_IsHalfHole: parseInt(this.orderFrom.det_IsHalfHole),
        Det_IsImp: parseInt(this.orderFrom.det_IsImp),
        Det_IsBGA: parseInt(this.orderFrom.det_IsBGA),
        Det_Isinvoice: parseInt(this.orderFrom.Det_Isinvoice),
        Area: parseFloat(this.orderFrom.area),
      };
      setTimeout(() => {
        getOrderApi
          .getAddordit({ content: JSON.stringify(obj), quantity: 1 })
          .then((res) => {
            this_.content = "购物车添加成功";
            this_.isShow = true;
          });
      }, 300);
    },
    // 计算价格
    // 计算价格
    async order() {
      this.orderFrom.det_IsHalfHole = 0;
      this.orderFrom.det_IsImp = 0;
      this.orderFrom.det_IsBGA = 0;
      this.specialArray.forEach((el) => {
        if (el == "半孔") {
          this.orderFrom.det_IsHalfHole = 1;
        }
        if (el == "阻抗") {
          this.orderFrom.det_IsImp = 1;
        }
        if (el == "BGA") {
          this.orderFrom.det_IsBGA = 1;
        }
      });
      this.content = "";
      this.isShow = false;
      let obj = {
        Det_BoardSize_W: parseFloat(this.orderFrom.det_BoardSize_W),
        Det_BoardSiez_H: parseFloat(this.orderFrom.det_BoardSiez_H),
        Det_Num: parseFloat(this.orderFrom.det_Num),
        Det_Pmodels: parseFloat(this.orderFrom.det_Pmodels),
        Det_BoardType: this.orderFrom.Det_BoardType,
        Det_BoardSupplier: this.orderFrom.Det_BoardSupplier,
        Det_Layer: parseFloat(this.orderFrom.Det_Layer),
        Det_BoardThickness: parseFloat(this.orderFrom.Det_BoardThickness),
        Det_Copper_out: this.orderFrom.Det_Copper_out,
        Det_Copper_in: this.orderFrom.Det_Copper_in,
        Det_ZHcolor: this.orderFrom.Det_ZHcolor,
        Det_TestMethod: this.orderFrom.Det_TestMethod,
        Det_Testingjig: this.orderFrom.Det_Testingjig,
        Det_Surface: this.orderFrom.Det_Surface,
        Det_TestPrice: parseInt(this.orderFrom.Det_TestPrice),
        Det_Receipt: parseInt(this.orderFrom.Det_Receipt),
        Det_LineSpacing: this.orderFrom.Det_LineSpacing,
        Det_MouldManner: this.orderFrom.Det_MouldManner,
        Det_mould: this.orderFrom.Det_mould,
        Det_IsHalfHole: parseInt(this.orderFrom.det_IsHalfHole),
        Det_IsImp: parseInt(this.orderFrom.det_IsImp),
        Det_IsBGA: parseInt(this.orderFrom.det_IsBGA),
        Det_Isinvoice: parseInt(this.orderFrom.Det_Isinvoice),
        Area: parseFloat(this.orderFrom.area),
        version: this.orderFrom.specificModels,
        Det_Copper_high: 0,
        useratio: 0,
      };
      if (
        this.orderFrom.det_BoardSize_W != "" &&
        this.orderFrom.det_BoardSiez_H != "" &&
        this.orderFrom.Det_Num != ""
      ) {
        this.fullscreenLoading = true;
        getOrderApi
          .getOrder(obj)
          .then((res) => {
            this.fullscreenLoading = false;
            this.Denominated = res.data.data[0];
            if (this.offerFrom.PuzzleMode != "3") {
              this.areaPrice =
                this.Denominated.Ordp_MakeBoard /
                ((this.orderFrom.det_BoardSiez_H *
                  this.orderFrom.det_BoardSize_W *
                  this.orderFrom.det_Num) /
                  10000);
            } else {
              this.areaPrice =
                this.Denominated.Ordp_MakeBoard /
                ((this.orderFrom.det_BoardSiez_H *
                  this.orderFrom.det_BoardSize_W *
                  this.orderFrom.det_Num) /
                  10000 /
                  (this.offerFrom.Process_W * this.offerFrom.Process_H));
            }
          })
          .catch((res) => {
            this.fullscreenLoading = false;
            this.content = "请输入完整的参数不然无法计价！！";
            this.isShow = true;
          });
      } else {
        this.content = "交货尺寸或者交货数量不能为空！！";
        this.isShow = true;
      }
      return this.Denominated;
    },

    // 拼版数量限制
    Process() {
      if (this.offerFrom.Process_H != "" || this.offerFrom.Process_W != "") {
        if (this.offerFrom.Process_W * this.offerFrom.Process_H > 10) {
          this.content = "拼板数量超出限制";
          this.isShow = true;
          this.offerFrom.Process_W = "";
          this.offerFrom.Process_H = "";
          return false;
        }
        this.number1();
        return true;
      }
      return false;
    },
    //拼版款数限制
    PuzzleChanges() {
      this.content = "";
      this.isShow = false;
      if (parseInt(this.orderFrom.det_Pmodels) < 1) {
        this.content = "拼板款数最小值为1，不得低于1";
        this.isShow = true;
        this.orderFrom.det_Pmodels = 1;
        return false;
      }
      return true;
    },
    // 工艺边限制
    TechnologyLimited() {
      this.isShow = false;
      if (this.offerFrom.Process_W < 3 || this.offerFrom.Process_H < 1.6) {
        this.offerFrom.Process_W = 3;
        this.offerFrom.Process_H = 1.6;
        this.content = "云上初阳代拼工艺宽度和拼版间距超出最小限制";
        this.isShow = true;
        return false;
      }
      return true;
    },
    // 交货数量限制
    Number() {
      this.isShow = false;
      this.content = "";
      if (this.orderFrom.det_Num % 5 != 0) {
        this.isShow = true;
        this.content = "交货数量必须是5的倍数";
        return false;
      }
      return true;
    },
    // 订单面积
    number1() {
      this.orderFrom.area = "";
      if (
        this.orderFrom.det_BoardSiez_H != "" &&
        this.orderFrom.det_BoardSize_W != "" &&
        this.orderFrom.det_Num != ""
      ) {
        if (this.offerFrom.PuzzleMode != 3) {
          this.orderFrom.area =
            (this.orderFrom.det_BoardSiez_H *
              this.orderFrom.det_BoardSize_W *
              this.orderFrom.det_Num) /
            10000;
          if (this.orderFrom.area > 5) {
            this.testList = [
              { label: "目测", value: "目测" },
              { label: "电测", value: "电测" },
            ];
          } else {
            this.testList = [
              { label: "目测", value: "目测" },
              { label: "飞针", value: "飞针" },
              { label: "电测", value: "电测" },
            ];
          }
          return true;
        } else {
          this.orderFrom.area =
            (this.orderFrom.det_BoardSiez_H *
              this.orderFrom.det_BoardSize_W *
              this.orderFrom.det_Num) /
            10000 /
            (this.offerFrom.Process_H * this.offerFrom.Process_W);
          if (this.orderFrom.area > 5) {
            this.testList = [
              { label: "目测", value: "目测" },
              { label: "电测", value: "电测" },
            ];
          } else {
            this.testList = [
              { label: "目测", value: "目测" },
              { label: "飞针", value: "飞针" },
              { label: "电测", value: "电测" },
            ];
          }
          return true;
        }
      }
      return;
    },
    //交货尺寸长限制
    BoardSize() {
      this.isShow = false;
      this.content = "";
      if (
        this.orderFrom.det_BoardSiez_H != "" ||
        this.orderFrom.det_BoardSize_W != ""
      ) {
        if (
          this.orderFrom.det_BoardSiez_H != "" &&
          this.orderFrom.det_BoardSize_W != ""
        ) {
          let w = parseFloat(this.orderFrom.det_BoardSize_W);
          let h = parseFloat(this.orderFrom.det_BoardSiez_H);
          this.number1();
          if ((w > 60 && h > 52) || (w > 52 && h > 60)) {
            this.isShow = true;
            this.content = "板材超出最大尺寸";
            this.orderFrom.det_BoardSiez_H = "";
            this.orderFrom.det_BoardSize_W = "";
            return false;
          } else if ((w < 7 && h < 5) || (w < 5 && h < 7)) {
            this.isShow = true;
            this.content = "板材超出最小尺寸";
            this.orderFrom.det_BoardSiez_H = "";
            this.orderFrom.det_BoardSize_W = "";
            return false;
          }
          return true;
        }
      }

      return false;
    },

    //发票管理
    invoiceChange(data) {
      this.orderFrom.Det_Isinvoice = data;
    },
    // 接受标准
    AcceptanceChange(data) {
      this.orderFrom.Acceptance = data;
    },
    // 打叉板
    standardChange(e) {
      this.offerFrom.standard = e;
    },
    // 特殊工艺
    specialChange(data) {
      this.specialArray = data;
    },
    // 丝印周期
    ScreenChange(data) {
      this.offerFrom.Screen = data;
    },
    // 测试费
    pleaseChange(data) {
      this.orderFrom.Det_TestPrice = data;
    },
    // 多选数组
    characterTagChange(data) {
      this.CharacterTagsArray = data;
      if (this.CharacterTagsArray.indexOf("丝印周期") == "-1") {
        this.offerFrom.Screen = "";
        this.isBJ = false;
      } else {
        this.offerFrom.Screen = "印周年";
        this.isBJ = true;
      }
    },
    // 收据/送货单
    receiptChange(data) {
      this.orderFrom.Det_Receipt = data;
    },
    // 磨具
    abrasiveChange(data) {
      this.orderFrom.Det_mould = data;
    },
    // 成型方式
    moldingChange(data) {
      this.orderFrom.Det_MouldManner = data;
      if (this.orderFrom.Det_MouldManner == "模冲") {
        this.orderFrom.Det_mould = "新开模具";
      } else {
        this.orderFrom.Det_mould = "";
      }
    },
    // 测试架
    TestTheChange(data) {
      this.orderFrom.Det_Testingjig = data;
      if (this.orderFrom.Det_Testingjig == "新开测试架") {
        return (this.orderFrom.Det_TestPrice = "500");
      } else {
        return (this.orderFrom.Det_TestPrice = "0");
      }
    },
    // 最小线宽线距
    spacingChange(data) {
      this.orderFrom.Det_LineSpacing = data;
    },
    // 确认生产稿
    draftChange(data) {
      this.offerFrom.draft = data;
    },
    // 测试
    testChange(data) {
      this.orderFrom.Det_TestMethod = data;
      if (this.orderFrom.Det_TestMethod == "电测") {
        this.orderFrom.Det_TestPrice = "500";
        this.orderFrom.Det_Testingjig = "新开测试架";
        return;
      } else {
        this.orderFrom.Det_TestPrice = "0";
        this.orderFrom.Det_Testingjig = "";
        return;
      }
    },
    // 表面处理
    surfaceChange(data) {
      this.orderFrom.Det_Surface = data;
    },
    // 最小线宽/线距
    apertureChange(data) {
      this.offerFrom.aperture = data;
    },
    // 过孔方式
    holeChange(data) {
      this.offerFrom.ViaWay = data;
    },
    // 字符颜色
    characterChange(data) {
      this.offerFrom.ZFcolor = data;
      if (
        this.offerFrom.ZFcolor == "黑色" &&
        this.orderFrom.Det_ZHcolor == "黑色"
      ) {
        this.orderFrom.Det_ZHcolor = "白色";
      } else if (
        this.offerFrom.ZFcolor == "白色" &&
        this.orderFrom.Det_ZHcolor == "白色"
      ) {
        this.orderFrom.Det_ZHcolor = "黑色";
      }
    },
    // 阻焊颜色
    ResistanceChange(data) {
      this.orderFrom.Det_ZHcolor = data;
      if (
        this.orderFrom.Det_ZHcolor == "黑色" &&
        this.offerFrom.ZFcolor == "黑色"
      ) {
        this.offerFrom.ZFcolor = "白色";
      } else if (
        this.orderFrom.Det_ZHcolor == "白色" &&
        this.offerFrom.ZFcolor == "白色"
      ) {
        this.offerFrom.ZFcolor = "黑色";
      }
    },
    // 内层铜厚
    theCopperThickChange(data) {
      this.orderFrom.Det_Copper_in = data;
    },
    // 外层铜厚
    copperThickChange(data) {
      this.orderFrom.Det_Copper_out = data;
    },
    // 成品板厚
    supplierChange(data) {
      this.orderFrom.Det_BoardSupplier = data;
      if (
        this.orderFrom.Det_BoardSupplier != "生益" &&
        this.orderFrom.Det_BoardType == "高频板"
      ) {
        this.$alert("请联系人工报价!", "提示", {
          confirmButtonText: "确定",
        });
      }
    },
    //板子厚度子组件返回赋值
    thicknessChange(data) {
      this.orderFrom.Det_BoardThickness = data;
      if (this.orderFrom.Det_BoardThickness != 0.4) {
        this.surfaceList = [
          { label: "有铅喷锡", value: "有铅喷锡" },
          { label: "无铅喷锡", value: "无铅喷锡" },
          { label: "OSP", value: "OSP" },
          { label: "沉金1U", value: "沉金1U" },
          { label: "沉金2U", value: "沉金2U" },
        ];
      } else {
        this.surfaceList = [
          { label: "OSP", value: "OSP" },
          { label: "沉金1U", value: "沉金1U" },
          { label: "沉金2U", value: "沉金2U" },
        ];
        this.orderFrom.Det_Surface = "OSP";
      }
    },
    // 板材类型子组件返回赋值
    plankChange(data) {
      this.orderFrom.Det_BoardType = data;

      if (this.orderFrom.Det_BoardType == "FR-4") {
        // 板子层数
        (this.layerList = [
          { label: "1", value: "1" },
          { label: "2", value: "2" },
          { label: "4", value: "4" },
        ]),
          // 成型方式
          (this.moldingList = [
            { label: "铣边", value: "铣边" },
            { label: "模冲", value: "模冲" },
          ]),
          // 最小线宽线距
          (this.spacingList = [
            { label: "4/5", value: "4/5mil" },
            { label: "5/5", value: "5/5mil" },
            { label: "6/6", value: "6/6mil" },
            { label: "7/7", value: "7/7mil" },
            { label: "8/8", value: "8/8mil" },
            { label: "9/9", value: "9/9mil" },
            { label: "10/10", value: "10/10mil" },
          ]),
          // 最小孔径数组
          (this.apertureList = [
            { label: "0.3", value: "0.30mm" },
            { label: "0.35", value: "0.35mm" },
            { label: "0.4", value: "0.40mm" },
            { label: "0.5", value: "0.50mm" },
            { label: "0.6", value: "0.60mm" },
            { label: "0.7", value: "0.70mm" },
            { label: "0.8", value: "0.80mm" },
          ]),
          // 表面处理
          (this.surfaceList = [
            { label: "有铅喷锡", value: "有铅喷锡" },
            { label: "无铅喷锡", value: "无铅喷锡" },
            { label: "OSP", value: "OSP" },
            { label: "沉金1U", value: "沉金1U" },
            { label: "沉金2U", value: "沉金2U" },
          ]),
          // 过孔方式
          (this.holeList = [
            { label: "过孔盖油", value: "过孔盖油" },
            { label: "过孔开窗", value: "过孔开窗" },
            { label: "按Gerber文件", value: "按Gerber文件" },
          ]),
          // 阻焊颜色
          (this.ResistanceList = [
            { label: "绿色", value: "绿色" },
            { label: "蓝色", value: "蓝色" },
            { label: "黄色", value: "黄色" },
            { label: "白色", value: "白色" },
            { label: "黑色", value: "黑色" },
          ]),
          // 板材供应商
          (this.supplierList = [
            { label: "国纪", value: "国纪" },
            { label: "建滔", value: "建滔" },
            { label: "生益", value: "生益" },
            { label: "无要求", value: "无要求" },
          ]);
        // 板子厚度
        this.thicknessList = [
          { label: "0.4", value: "0.4" },
          { label: "0.6", value: "0.6" },
          { label: "0.8", value: "0.8" },
          { label: "1", value: "1.0" },
          { label: "1.2", value: "1.2" },
          { label: "1.6", value: "1.6" },
          { label: "2", value: "2.0" },
        ];
        this.copperThickList = [
          { label: "1", value: "1oz" },
          { label: "1.5", value: "1.5oz" },
          { label: "2", value: "2oz" },
        ];
        (this.theCopperThickList = [
          { label: "1", value: "1oz" },
          { label: "1.5", value: "1.5oz" },
          { label: "2", value: "2oz" },
        ]),
          (this.InCopperFoil = "内层铜厚");
        this.orderFrom.Det_Copper_out = "1";
        this.orderFrom.Det_MouldManner = "铣边";
        // 最小线宽
        this.orderFrom.Det_LineSpacing = "10/10";
        // 最小孔径
        this.offerFrom.aperture = "0.8";
        this.orderFrom.Det_TestMethod = "目测";
        // 板子厚度
        this.orderFrom.Det_BoardThickness = "0.8";
        // 名称修改
        this.thicknessBoard = "成品板厚";
        // 名称修改
        this.CopperFoil = "成品外层铜厚";
        // 表面处理
        this.orderFrom.Det_Surface = "有铅喷锡";
        // 过孔方式
        this.offerFrom.ViaWay = "按Gerber文件";
        // 板材具体型号
        this.orderFrom.specificModels = "";
        // 板材默认供应商
        this.orderFrom.Det_BoardSupplier = "国纪";
        this.orderFrom.Det_Layer = "2";
        return;
      } else if (this.orderFrom.Det_BoardType == "高频板") {
        // 板子层数
        // 板子层数
        (this.layerList = [
          { label: "1", value: "1" },
          { label: "2", value: "2" },
          { label: "4", value: "4" },
          { label: "6", value: "6" },
        ]),
          // 成型方式
          (this.moldingList = [{ label: "铣边", value: "铣边" }]),
          // 最小线宽
          (this.spacingList = [
            { label: "4/4", value: "4/4mil" },
            { label: "5/5", value: "5/5mil" },
            { label: "6/6", value: "6/6mil" },
            { label: "7/7", value: "7/7mil" },
            { label: "8/8", value: "8/8mil" },
            { label: "10/10", value: "10/10mil" },
          ]),
          // 最小孔径数组
          (this.apertureList = [
            { label: "0.25", value: "0.25mm" },
            { label: "0.3", value: "0.30mm" },
            { label: "0.35", value: "0.35mm" },
            { label: "0.4", value: "0.40mm" },
            { label: "0.5", value: "0.50mm" },
            { label: "0.6", value: "0.60mm" },
            { label: "0.7", value: "0.70mm" },
            { label: "0.8", value: "0.80mm" },
          ]),
          // 表面处理
          (this.surfaceList = [
            { label: "沉锡", value: "沉锡" },
            { label: "沉金1U", value: "沉金1U" },
            { label: "沉金2U", value: "沉金2U" },
            { label: "沉银", value: "沉银" },
            { label: "OSP", value: "OSP" },
            { label: "无铅喷锡", value: "无铅喷锡" },
          ]),
          // 过孔方式
          (this.holeList = [
            { label: "过孔盖油", value: "过孔盖油" },
            { label: "过孔开窗", value: "过孔开窗" },
          ]),
          // 阻焊颜色
          (this.ResistanceList = [
            { label: "绿色", value: "绿色" },
            { label: "白色", value: "白色" },
            { label: "蓝色", value: "蓝色" },
            { label: "黑色", value: "黑色" },
            { label: "红色", value: "红色" },
            { label: "无", value: "无" },
          ]),
          (this.orderFrom.Det_BoardSupplier = "生益");
        // 板材供应商
        this.supplierList = [
          { label: "生益", value: "生益" },
          { label: "富仕德", value: "富仕德" },
          { label: "华正", value: "华正" },
          { label: "其他", value: "其他" },
        ];

        this.copperThickList = [{ label: "35/35", value: "35/35" }];
        // 板子厚度
        this.thicknessList = [
          { label: "0.203", value: "0.203" },
          { label: "0.787", value: "0.787" },
        ];

        this.specificistList = [
          { label: "S7439HW", value: "S7439HW" },
          { label: "S7439HW-ANT", value: "S7439HW-ANT" },
          { label: "SCGA-500GF300", value: "SCGA-500GF300" },
          { label: "SG3300", value: "SG3300" },
        ];
        this.orderFrom.specificModels = "S7439HW";

        this.orderFrom.Det_MouldManner = "铣边";

        this.offerFrom.aperture = "0.8";
        this.thicknessBoard = "板材厚度(基材)";
        this.CopperFoil = "铜箔厚度(基材)";
        this.orderFrom.Det_BoardThickness = "0.203";
        this.orderFrom.Det_Surface = "沉锡";
        this.offerFrom.ViaWay = "过孔盖油";
        this.orderFrom.Det_TestMethod = "目测";
        // 最小线宽
        this.orderFrom.Det_Copper_out = "35/35";
        this.orderFrom.Det_LineSpacing = "10/10";
        this.orderFrom.Det_Layer = "2";
        return;
      }
    },
    // 拼版方式数据子组件返回赋值
    puzzlechange(data) {
      this.offerFrom.PuzzleMode = data;
      this.offerFrom.Process_W = "";
      this.offerFrom.Process_H = "";
      this.CanceDialog();
    },
    // 板子层数数据子组件返回赋值
    LayerChange(data) {
      this.orderFrom.Det_Layer = data;
      if (
        this.orderFrom.Det_Layer >= 4 &&
        this.orderFrom.Det_BoardType != "高频板"
      ) {
        this.orderFrom.Det_Copper_in = 1;
        (this.supplierList = [
          { label: "建滔", value: "建滔" },
          { label: "生益", value: "生益" },
        ]),
          (this.thicknessList = [
            { label: "0.6", value: "0.6" },
            { label: "0.8", value: "0.8" },
            { label: "1", value: "1.0" },
            { label: "1.2", value: "1.2" },
            { label: "1.6", value: "1.6" },
            { label: "2", value: "2.0" },
          ]);
        if (this.orderFrom.Det_BoardThickness == "0.4") {
          this.orderFrom.Det_BoardThickness = "0.6";
        }
        if (this.orderFrom.Det_BoardSupplier == "国纪") {
          this.orderFrom.Det_BoardSupplier = "建滔";
        }
        return;
      } else if (
        this.orderFrom.Det_BoardType != "高频板" &&
        this.orderFrom.Det_Layer <= 4
      ) {
        this.orderFrom.Det_Copper_in = 0.5;
        (this.supplierList = [
          { label: "国纪", value: "国纪" },
          { label: "建滔", value: "建滔" },
          { label: "生益", value: "生益" },
          { label: "无要求", value: "无要求" },
        ]),
          (this.thicknessList = [
            { label: "0.4", value: "0.4" },
            { label: "0.6", value: "0.6" },
            { label: "0.8", value: "0.8" },
            { label: "1", value: "1.0" },
            { label: "1.2", value: "1.2" },
            { label: "1.6", value: "1.6" },
            { label: "2", value: "2.0" },
          ]);
      }
      if (
        this.orderFrom.Det_Layer < 4 &&
        this.orderFrom.Det_BoardType == "高频板"
      ) {
        this.copperThickList = [{ label: "35/35", value: "35/35" }];
        this.moldingList = [{ label: "铣边", value: "铣边" }];
        if (this.orderFrom.Det_Layer == "1") {
          this.specificistList = [
            { label: "S7439HW", value: "S7439HW" },
            { label: "S7439HW-ANT", value: "S7439HW-ANT" },
            { label: "SG3300", value: "SG3300" },
          ];
          this.orderFrom.specificModels = "S7439HW";
          this.thicknessList = [
            { label: "0.203", value: "0.203" },
            { label: "0.787", value: "0.787" },
          ];
          return (this.orderFrom.Det_BoardThickness = "0.203");
        } else if (this.orderFrom.Det_Layer == "2") {
          this.specificistList = [
            { label: "S7439HW", value: "S7439HW" },
            { label: "S7439HW-ANT", value: "S7439HW-ANT" },
            { label: "SCGA-500GF300", value: "SCGA-500GF300" },
            { label: "SG3300", value: "SG3300" },
          ];
          this.orderFrom.specificModels = "S7439HW";
          this.thicknessList = [
            { label: "0.203", value: "0.203" },
            { label: "0.787", value: "0.787" },
          ];
          return (this.orderFrom.Det_BoardThickness = "0.203");
        }

        this.orderFrom.Det_MouldManner = "铣边";
        this.CopperFoil = "铜箔厚度(基材)";
        this.orderFrom.Det_Copper_out = "35/35";
        this.orderFrom.Det_BoardThickness = "0.203";
      } else if (
        this.orderFrom.Det_Layer >= 4 &&
        this.orderFrom.Det_BoardType == "高频板"
      ) {
        // 板子厚度
        this.$alert("请联系人工报价", "提示", {
          confirmButtonText: "确定",
        });
        return;
        this.copperThickList = [
          { label: "1", value: "1oz" },
          { label: "1.5", value: "1.5oz" },
          { label: "2", value: "2.0oz" },
        ];
        // 内层铜厚
        (this.theCopperThickList = [
          { label: "1", value: "1oz" },
          { label: "1.5", value: "1.5oz" },
          { label: "2", value: "2.0oz" },
        ]),
          (this.moldingList = [{ label: "铣边", value: "铣边" }]),
          (this.CopperFoil = "铜箔厚度(外层)");
        this.InCopperFoil = "铜箔厚度(内层)";
        this.orderFrom.Det_Copper_out = "1";
        this.orderFrom.Det_MouldManner = "铣边";
        this.orderFrom.Det_BoardThickness = "0.203";
      }
    },
    CanceDialog(e) {
      this.offerFrom.set = 0;

      if (this.offerFrom.PuzzleMode == 1 || this.offerFrom.PuzzleMode == 2) {
        this.offerFrom.set = this.orderFrom.det_Num;
        this.number1();
        return true;
      } else {
        if (this.offerFrom.Process_W != "" && this.offerFrom.Process_H != "") {
          if (this.Process()) {
            this.offerFrom.set =
              this.orderFrom.det_Num /
              (this.offerFrom.Process_W * this.offerFrom.Process_H);
            this.number1();
            return true;
          }
        }
      }
    },

    //   点击隐藏
    According(i) {
      switch (i) {
        case 1:
          this.show.basic = !this.show.basic;
          break;
        case 2:
          this.show.PCB = !this.show.PCB;
          break;
        case 3:
          this.show.personality = !this.show.personality;
          break;
        case 4:
          this.show.special = !this.show.special;
          break;
        case 5:
          this.show.other = !this.show.other;
          break;
      }
    },
  },
  //  私有组件
  components: {
    myTitle: title,
    radioBtn,
    checkboxBtn,
    isShow,
    dropDown,
  },
};
</script>
<style lang="scss" scoped>
// 在填充数据之前隐藏
[v-cloak] {
  display: none;
}
.myTitle1 {
  width: 13rem !important;
  display: inline-block !important;
  padding-left: 1.5rem !important;
}
.myTitle {
  width: 12rem !important;
  display: inline-block !important;
  padding-left: 1.5rem !important;
}
.OnlineInvoicing {
  width: 70%;
  margin: auto;
  .table {
    margin-top: 2rem;
    margin-left: 2rem;
    background-color: #b0d5df;
    // border: 0.1rem solid #000000;
    border-radius: 0.5rem;
    // 商品价格
    .box {
      border: 0.1rem solid #ffffff;
      margin: auto;
      width: 80%;
      margin-top: 1rem;
      div {
        display: flex;
        justify-content: center;
        font-size: 1rem;
        div {
          flex: 1;
        }
      }
    }
    //费用表
    .cost {
      div {
        text-align: left;
        margin-left: 0.5rem;
        font-size: 1rem;
      }
    }
    // 明细显示框
    .detail {
      margin: auto;
      margin-top: 1rem;
      width: 80%;
      border: 0.1rem solid #fff;
      border-radius: 0.3rem;
      box-sizing: border-box;

      div {
        display: flex;
        flex-wrap: wrap;
        div {
          font-weight: 300;
          width: 50%;
          span {
            width: 80px;
            text-align-last: justify;
            text-align: justify;
            font-size: 1rem;
            font-weight: 500;
          }
          i {
            color: #f00;
            text-align-last: center;
            text-align: center;
            font-size: 1.1rem;
          }
        }
      }
    }
    hr {
      display: inline-block;
      width: 5rem;
      margin-bottom: 0.3rem;
      color: #000000;
      background-color: #000000;
    }
    //订单交期
    .delivery {
      display: flex;
      flex-wrap: wrap;
      .el-radio.is-bordered + .el-radio.is-bordered {
        margin: auto;
        margin-top: 0.5rem;
      }
      .el-radio {
        margin: auto;
        margin-top: 0.5rem;
        text-align: left;
        width: 80%;
      }
    }
    // 计较表价格
    .price {
      padding-top: 1rem;
      text-align: left;
    }
    // 计较表头
    .headr {
      background-color: #83cbac;
      width: 100%;
      font-size: 1.2rem;
      display: inline-block;
      padding: 0.3rem 0;
      border-top-right-radius: 0.5rem;
      border-top-left-radius: 0.5rem;
      color: #fff;
    }
    div {
      font-size: 1.2rem;
      text-align: center;
      background-color: #fff;
      color: #000;
      margin: 0;
      padding: 0;
    }
  }
  div {
    margin: auto;
    div {
      margin-top: 0.5rem;

      .flex {
        display: flex;
        width: 100%;
        .bg {
          // background: #555;
          //   background-image: url(../../assets/imges/28.png);
          //   background-repeat: no-repeat;
          //   background-size: 100%;
          background-color: #83cbac;
          width: 100%;
          background-position-y: -40px;
        }
        .box {
          margin: 0;
          width: 100%;
          border: 0.1rem solid #ddd;
          border-radius: 0 0 0.2rem 0.2rem;
          ul li {
            display: flex;

            i {
              font-style: unset;
              font-size: 1.5rem;
            }
            .el-input {
              width: 10rem;
            }
          }
        }
        div {
          width: 80%;
          align-content: center;
          border-radius: 0.2rem 0.2rem 0 0;
          p {
            display: inline-block;
            width: 95%;
            color: #ffffff;
            padding-bottom: 0.2rem;
            padding-left: 0.8rem;
          }
          img {
            margin-top: 0.5rem;
            width: 1.5rem;
            flex: 1;
          }
        }
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/view/home/OnlineInvoicing.vue